module.exports = __webpack_public_path__ + "static/img/via_in_pad.334367b2.png";